import React, { Component } from 'react';
import config from './config'
import MainDrawer from './InternalNavigation/drawer';
import InternalNavigation from './InternalNavigation';
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { actions, selectors } from './sagas/checkout';
import CheckoutForm from './CheckoutForm';
import { TextInput } from './shared/TextInput'
import { Field } from 'redux-form';
import { FormError } from './shared/FormError'
import { reduxForm } from 'redux-form';

class Tips extends Component {
  constructor(props) {
    super(props);
    this.state = {
      stripe: undefined,
    }
    this.getOrder = this.props.getOrder.bind(this)
  }

  componentWillMount () {
    this.getOrder(this.props.match.params.orderId)
  }

  checkRole = (minRole, role) => {
    return this.roleCanView() && this.roleCanView()[role] && this.roleCanView()[role].includes(minRole)
  }

  roleCanView = () => ({
    'admin': ['admin', 'accountant', 'user'],
    'accountant': ['accountant', 'user'],
    'user': ['user'],
    'non_user': []
  })

  handlePayWithCash = () => {
    this.props.payWithCash(this.props.order['id'])
  }

  tipAmount = (total_price, percent) => {
    return parseFloat(Math.round((total_price * percent) * 100) / 100).toFixed(2)
  }

  addTip = (total_price, percent) => {
    this.props.addTip(this.tipAmount(total_price, percent), this.props.order['id'], this.checkoutType(), 'percent')
  }

  addCustomTip = () => {
    this.props.addTip(undefined, this.props.order['id'], this.checkoutType(), 'custom')
  }

  checkoutType = () => {
    return this.props
      && this.props.location
      && this.props.location.state
      && this.props.location.state.type
  }

  normalizeCurrency = (val) => {
		return val.replace(/,/g , '');
	}

	formatCurrency = (input) => {
    if (input === undefined || input === null) return ''
		if (isNaN(parseInt(input[input.length - 1], 10))) {
					return input.slice(0, -1);
				}

    const cleanedInput = input.replace(/,/g , '');
		const convertedInput = new Intl.NumberFormat().format(cleanedInput);

		return convertedInput;
	}

  render () {
    let order = this.props.order
    let total_price = order && order['attributes'] && order['attributes']['price'] && order['attributes']['price']['totalPrice']
    let companyCheckout = this.props.location && this.props.location.state && this.props.location.state.companyCheckout
    let companySupportsCashCheckout = order && order['attributes'] && order['attributes']['accountSupportsPaidWithCash']
    return (
      <div style={{ width: '100%', display: 'flex', flexDirection: 'row'}}>
        { this.checkRole('user', this.props.role) &&
          <div>
            <MainDrawer
              position={'left'}
              openState={this.state.drawer}
              toggleDrawer={this.toggleDrawer}
              className='drawer'/>
            <InternalNavigation
              toggleDrawer={this.toggleDrawer}/>
          </div>
          }
        <div style={ styles.checkoutPage }>
          <div style={{ width: 315 }}>
            <div style={ styles.title }>
              Add a Tip
            </div>
          </div>
          <div>
            { this.props.errors && Object.keys(this.props.errors).length > 0 &&
              <FormError errors={this.props.errors}/>
            }
            { this.props.order &&
              <div style={{ display: 'flex', alignItems: 'center'}}>
                <div style={ styles.totalPriceWrap }>
                  <div style={ styles.priceText }>
                    Total
                  </div>
                  <div style={ styles.priceText }>
                    { total_price }
                  </div>
                </div>
              </div>
            }
            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center' }}>
              <div onClick={ () => this.addTip(total_price, .05) } style={styles.tipButton}>
                <div style={ styles.percentText }>
                  5%
                </div>
                <div style={ styles.priceText }>
                  ${ this.tipAmount(total_price, 0.05) }
                </div>
              </div>
            </div>
            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center' }}>
              <div onClick={ () => this.addTip(total_price, .10) } style={styles.tipButton}>
                <div style={ styles.percentText }>
                  10%
                </div>
                <div style={ styles.priceText }>
                  ${ this.tipAmount(total_price, 0.10) }
                </div>
              </div>
            </div>
            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center' }}>
              <div onClick={ () => this.addTip(total_price, .15) } style={styles.tipButton}>
                <div style={ styles.percentText }>
                  15%
                </div>
                <div style={ styles.priceText }>
                  ${ this.tipAmount(total_price, 0.15) }
                </div>
              </div>
            </div>
            <div style={{ marginTop: 17, display: 'flex', flexDirection: 'row', justifyContent: 'center' }}>
              <Field
                autoFocus={false}
                inputName={'tipAmount'}
                label={'Tip Amount'}
                name='tipAmount'
                component={TextInput}
                keyboardType={'decimal-pad'}
                placeholder={'$'}
                normalize={ this.normalizeCurrency }
                format={ this.formatCurrency }
                errors={this.props.errors}
                label='Custom Tip Amount' />
            </div>
            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center' }}>
              <div
                style={{
                  height: 32,
                  flex: .45,
                  borderStyle: 'solid',
                  borderBottomColor: '#D8D8D8',
                  borderBottomWidth: 1,
                  borderTopWidth: 0,
                  borderLeftWidth: 0,
                  borderRightWidth: 0
                }}
              >
                <div>
                  &nbsp;
                </div>
              </div>
              <div style={{ height: 60, flex: .10, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <div style={{ ...styles.priceText, ...{ color: '#D8D8D8' }}}>
                  Or
                </div>
              </div>
              <div
                style={{
                  height: 32,
                  flex: .45,
                  borderStyle: 'solid',
                  borderBottomColor: '#D8D8D8',
                  borderBottomWidth: 1,
                  borderTopWidth: 0,
                  borderLeftWidth: 0,
                  borderRightWidth: 0
                }}
              >
                <div>
                  &nbsp;
                </div>
              </div>
            </div>
            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center' }}>
              <button
                style={styles.button}
                textStyle={{ color: 'black' }}
                type={ 'secondary' }
                onClick={() => this.addTip(total_price, 0)}
             >
               No Tip
             </button>
            </div>
            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center' }}>
              <button
                style={styles.button}
                onClick={() => this.addCustomTip(total_price, null)}
              >
                Done
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
};
const styles = {
  checkoutPage: {
    display: 'flex',
    width: 315,
    margin: 30,
    marginTop: 70,
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    flex: 1
  },
  totalPriceWrap: {
    borderLeftWidth: 0,
    borderRightWidth: 0,
    display: 'flex',
    flexDirection: 'row',
    width: 315,
    height: 30,
    alignItems: 'center',
    justifyContent: 'space-between',
    borderStyle: 'solid',
    borderTopColor: '#D8D8D8',
    borderTopWidth: 1,
    borderBottomColor: '#D8D8D8',
    borderBottomWidth: 1,
  },
  tipButton: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'white',
    borderColor: 'black',
    borderStyle: 'solid',
    borderWidth: 1,
    color: 'black',
    marginTop: 30,
    width: 315,
    height: 60,
    borderRadius: 4
  },
  button: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'white',
    borderColor: 'black',
    borderStyle: 'solid',
    borderWidth: 1,
    color: 'black',
    marginTop: 30,
    width: 315,
    height: 40,
    borderRadius: 4
  },
  title: {
    fontSize: 18,
    fontFamily: 'Montserrat',
    color: '#4D4D4D',
    marginBottom: 14
  },
  percentText: {
    marginRight: 5,
    fontSize: 16,
    fontWeight: '600',
    fontFamily: 'montserrat',
    color: '#4D4D4D',
  },
  priceText: {
    fontSize: 14,
    fontWeight: '600',
    fontFamily: 'montserrat',
    color: '#4D4D4D',
  }
}

const mapStateToProps = (store) => ({
  order: selectors.order(store),
  order_info: selectors.order_info(store),
  customer_id: selectors.customer_id(store),
  customer: selectors.customer,
  errors: selectors.errors(store),
})

const mapDispatchToProps = (dispatch) => bindActionCreators(actions, dispatch)

export default (connect(mapStateToProps, mapDispatchToProps)(
  reduxForm(
  {
    form: 'add_tip_form'
  }
)(Tips)))




// WEBPACK FOOTER //
// ./src/Tips.jsx